module.exports = __webpack_public_path__ + "static/media/doc-uploaded.9ca33635.png";